const checkWorkstreamLeadApprovalStatus = (initiative) => {
    if (initiative && initiative.request && initiative.request.requestedStage) {
      const stage = initiative.stage;
      const requestedStage = initiative.request.requestedStage;
      let approvalStageKey = null;
  
      if ((stage === 'L0' || stage === 'L1') && requestedStage === 'Submitted for L1 Approval') {
        approvalStageKey = 'L1';
      } else if ((stage === 'L1' || stage === 'L2') && requestedStage === 'Submitted for L2 Approval') {
        approvalStageKey = 'L2';
      } else if ((stage === 'L2' || stage === 'L3') && requestedStage === 'Submitted for L3 Approval') {
        approvalStageKey = 'L3';
      } else if ((stage === 'L3' || stage === 'L4') && requestedStage === 'Submitted for L4 Approval') {
        approvalStageKey = 'L4';
      } else if ((stage === 'L4' || stage === 'L5') && requestedStage === 'Submitted for L5 Approval') {
        approvalStageKey = 'L5';
      } else {
        return 'Not Set'; // Skip if the stage and requested stage don't match our logic
      }
  
      if (initiative.approvalSummary && initiative.approvalSummary[approvalStageKey]) {
        const approvers = initiative.approvalSummary[approvalStageKey].approvers || [];
        if (approvers.length === 0) {
          return 'Pending';
        } else if (approvers.length >= 1) {
          return 'Approved';
        }
      } else {
        return 'Not Set';
      }
    }
    return 'Not Set'; // Return 'Not Set' if no request information is available
  };
  
  export default checkWorkstreamLeadApprovalStatus;